import { createContext, useContext, useState } from "react";

// Contesto condiviso tra le pagine (che registrano la scheda corrente) e il widget
// dell'assistente virtuale (che la usa per scorciatoie e risposte contestuali).
const AssistantContext = createContext({ productCtx: null, setProductCtx: () => {} });

export const AssistantProvider = ({ children }) => {
  const [productCtx, setProductCtx] = useState(null);
  return (
    <AssistantContext.Provider value={{ productCtx, setProductCtx }}>
      {children}
    </AssistantContext.Provider>
  );
};

export const useAssistant = () => useContext(AssistantContext);
